<navbar></navbar>
<div class="container bg-white">
    <div class="row">
        <div class="col">
            <h1>Briefing</h1>

            <p>Recruit <span class="redacted">Arrowman</span>,</p>
 
            <p>Welcome to the 2023 G17S Conclave!</p>

            <p><span class="redacted">You have been assigned</span>Seek<span class="redacted">
                missions, your goal is to compete with your fellow recruits and 
                complete as many as possible by the end of the weekend</span>.</p> 

            <p>You have been assigned missions, your goal is to compete with your fellow recruits and 
                complete as many as possible by the end of the weekend.</p> 
                
            <p>Each of these will bring you one step closer to receiving your license to serve. Included
                is a map and schedule to aid in your mission. Good luck.</p>

            <p>Serve <span class="redacted">Each of these will bring you one step closer to receiving your license to serve. Included
                is a map and schedule to aid in</span> faithful <span class="redacted">mission. Good luck</span>!</p>
        </div>
    </div>
</div>
